import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { AppService } from '../../../app.service';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { CatalogItemObjectConverter } from './catalog.converter';
import { CatalogTreeObjectConverter } from './catalog.tree.converter';
import { CatalogInfoObjectConverter } from './catalog.info.converter';
import { CatalogItemObject } from 'src/app/models/catalog/catalog-item-object.model';
import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';
import { CatalogInfoObject } from 'src/app/models/catalog/catalog-info-object.model';
import { of } from 'rxjs/internal/observable/of';
import { SearchObject } from 'src/app/layout/orders/search-orders/orders-body/orders-body.component';
import { ServiceTemplateData } from 'src/app/models/interface/serviceTemplate/serviceTemplateData';
import { ServiceTemplate } from 'src/app/models/interface/serviceTemplate/serviceTemplate';
import { ServiceTemplateRequest } from 'src/app/models/interface/serviceTemplate/serviceTemplateRequest';

//Probar el tema del error.undefined

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService,
    private catalogItemObjectConverter: CatalogItemObjectConverter,
    private catalogTreeObjectConverter: CatalogTreeObjectConverter,
    private catalogInfoObjectConverter: CatalogInfoObjectConverter
  ) {
    this.appData = appService.settings;
  }

  isOrquestable(ispCode: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.appData.webApi}/catalog/products/orquestable/${ispCode}`);
  }

  getJobStatus(): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/catalog/job/getJobStatus`);
  }

  load(file: File, progressCallback: (loaded: number, total: number) => void): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(`${this.appData.webApi}/catalog/job/load`, formData, {
      reportProgress: true,
      observe: 'events',
    })
      .pipe(
        tap(event => {
          if (event.type === HttpEventType.UploadProgress) {
            progressCallback(event.loaded, event.total);
          }
        }),
        filter(event => event.type === HttpEventType.Response),
        map((event: HttpResponse<any>) => event.body),
      );
  }


  getCatalog(): Observable<Map<string, Array<CatalogItemObject>>> {
    return this.httpClient.get<Map<string, Array<CatalogItemObject>>>(`${this.appData.webApi}/catalog/technicalProducts`)
      .pipe(
        map((technicalProducts: any) => {
          const catalog: any = JSON.parse(JSON.stringify(technicalProducts));
          return this.catalogItemObjectConverter.convert(catalog);
        })
      );
  }

  getCatalogTree(technicalProductId: string): Observable<CatalogTreeCardObject> {
    return this.httpClient.get<CatalogTreeCardObject>(`${this.appData.webApi}/catalog/technicalProducts/${technicalProductId}/tree`)
      .pipe(
        map((tree: any) => {
          const catalog: any = JSON.parse(JSON.stringify(tree));
          return this.catalogTreeObjectConverter.convert(catalog);
        })
      );
  }

  getItemInfo(itemId: string, type: string): Observable<CatalogInfoObject> {
    let url: string;
    switch (type) {
      case 'PRODUCT': {
        url = `${this.appData.webApi}/catalog/technicalProducts/${itemId}/product`;
        break;
      }
      case 'CFS': {
        url = `${this.appData.webApi}/catalog/technicalProducts/${itemId}/service/cfs`;
        break;
      }
      case 'RFS': {
        url = `${this.appData.webApi}/catalog/technicalProducts/${itemId}/service/rfs`;
        break;
      }
      default: {
        return of<CatalogInfoObject>(CatalogInfoObject.create());
      }
    }
    return this.httpClient.get<CatalogInfoObject>(url).pipe(
      map((response: any) => {
        const info: any = JSON.parse(JSON.stringify(response));
        return this.catalogInfoObjectConverter.convert(info);
      })
    );
  }

  getServiceTemplates(searchObject?: SearchObject): Observable<ServiceTemplateData> {

    let params = new HttpParams();

    if (searchObject) {
      params = params.append('page', searchObject.getPage().toString());
      params = params.append('size', searchObject.getSize().toString());
      params = params.append('sort', searchObject.getSort()[0]._key + ',' + searchObject.getSort()[0]._value);
    }

    return this.httpClient.get<ServiceTemplateData>(`${this.appData.webApi}/catalog/serviceTemplate`, { params });
  }

  createServiceTemplate(serviceTemplateRequest: ServiceTemplateRequest): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/catalog/serviceTemplate`, serviceTemplateRequest);
  }

  deleteServiceTemplate(namingId: string): Observable<any> {
    return this.httpClient.delete<any>(`${this.appData.webApi}/catalog/serviceTemplate/${namingId}`);
  }

  updateServiceTemplate(namingId: string, serviceTemplateRequest: ServiceTemplateRequest): Observable<ServiceTemplateData> {
    return this.httpClient.put<ServiceTemplateData>(`${this.appData.webApi}/catalog/serviceTemplate/${namingId}`, serviceTemplateRequest);
  }

  getCustomServiceSpec(technicalServiceId: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/catalog/custom/getServiceSpecification/${technicalServiceId}`);
  }

  getSimpleItemForm(type: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/catalog/utils/getSimpleItemForm/${type}`);
  }
  getComboItemForm(type: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/catalog/utils/getComboItemForm/${type}`);
  }

  getServiceTemplateSpec(): Observable<any> {
    return this.httpClient.get<any>(`${this.appData.webApi}/catalog/custom/getServiceTemplateSpec`);
  }

}